import { useState } from "react";
import { useLanguage } from "../contextApi/languageContext";

const LanguageDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: "en", name: "English", dir: "ltr", avatar: "En", color: "#c69933" },
    { code: "ar", name: "العربية", dir: "rtl", avatar: "Ar", color: "#c69933" },
  ];

  const selectedLanguage =
    languages.find((lang) => lang.code === language) || languages[0];

  const handleLanguageChange = (lang) => {
    setLanguage(lang.code);
    setIsOpen(false);
    // Optionally set text direction: document.documentElement.dir = lang.dir;
  };

  return (
    <div className="dropdown">
      <div
        className="d-flex align-items-center rounded-pill hover-effect"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label="Language selector"
        style={{ cursor: "pointer" }} // This adds the pointer cursor
      >
        <span
          className="d-inline-flex justify-content-center align-items-center rounded-circle me-1"
          style={{
            width: "35px",
            height: "35px",
            fontWeight: "bold",
            fontSize: "14px",
            border: `2px solid ${selectedLanguage.color}`,
            color: selectedLanguage.color,
            backgroundColor: "#f8f9fa",
            transition: "all 0.2s ease", // Smooth transition for hover effects
          }}
        >
          {selectedLanguage.avatar}
        </span>
      </div>

      {isOpen && (
        <ul className="dropdown-menu show mt-2" style={{ minWidth: "100%" }}>
          {languages.map((lang) => (
            <li key={lang.code}>
              <button
                className={`dropdown-item d-flex align-items-center ${
                  language === lang.code ? "active" : ""
                }`}
                onClick={() => handleLanguageChange(lang)}
              >
                <span
                  className="d-inline-flex justify-content-center align-items-center rounded-circle me-1"
                  style={{
                    width: "35px",
                    height: "35px",
                    fontWeight: "bold",
                    fontSize: "14px",
                    border: `2px solid ${selectedLanguage.color}`,
                    color: selectedLanguage.color,
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  {lang.avatar}
                </span>
                <span className="fw-bold">{lang.name}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
